import Model from "../Model";

class ComercialInfoUser extends Model{

    buildUrl ({ param }) {
        return ['zoneview/infobyuserid', param];
    }

    all(config = {}) {
        return this.request({ method: 'POST', action: 'all', ...config });
    }
}


export default new ComercialInfoUser;